import React, { Component } from 'react';

class FilterInput extends Component {

	constructor(props)
	{
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e)
	{
		this.props.onChange(e.target);
	}

	render()
	{
		return (
			<input type={ this.props.type } className="field" name={ this.props.name } id={ this.props.name } value={this.props.selected} onChange={this.handleChange} />
		);
	}
}

export default FilterInput;
